import { ProposalStatus } from '@sondermind/utilities/models-scheduling';

import { IAppointment } from './appointment.interface';

/**
 * A propose-a-time request that is still live: pending provider approval and not canceled.
 * Single source of truth for the pending-PaT contract shared by the appointments store and any
 * consumer that offers actions (e.g. reschedule) on a still-open request.
 */
export function isLivePendingPat(
  appointment: Pick<IAppointment, 'proposalStatus' | 'canceled'>
): boolean {
  return appointment.proposalStatus === ProposalStatus.PENDING && !appointment.canceled;
}
